// rafce

const Signature = () => {
  return (
    <>
        <div className="signature">
            <div>
                <p>
                    © 2023 Todos los derechos reservados.
                </p>
            </div>
            <div>
                <h6>
                    Sitio web desarrollado por <a href="https://southbridge.com.ar/" target="_blank" rel="noopener noreferrer">&#60;southBridge> IT Solutions</a>
                </h6>
            </div>
        </div>
    </>
  )
}

export default Signature
